import { ReactNode } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./styles.css";

const TooltipConfig = ({
  content,
  children,
  style,
  placement,
}: {
  content: string[];
  children: ReactNode;
  style: boolean;
  placement?: string;
}) => {
  return (
    <div style={{ display: "inline-block",height:'100%'}}>
      <OverlayTrigger
        placement={placement && placement === "bottom" ? placement : "top"}
        overlay={
          <Tooltip id={style ? "tooltip-top" : "tooltip-top-color"} >
            {content.length > 1
              ? content.map((value: string) => <article>{value}</article>)
              : content[0]}
          </Tooltip>
        }
      >
        <div className="align-children">{children}</div>
      </OverlayTrigger>
    </div>
  );
};

export default TooltipConfig;
